import gql from 'graphql-tag';

export default gql`
  mutation adminRestoreOrganization($organizationId: ID!) {
    adminRestoreOrganization(organizationId: $organizationId) {
      id
    }
  }
`;
